import logoVideo from "../asset/Home/AI_LOGO.mp4";
import menuIcon from "../asset/Home/menu.svg";
import { useState , useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
function Navbar(){
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
  if (location.state?.scrollTo) {
    document
      .getElementById(location.state.scrollTo)
      ?.scrollIntoView({
        behavior: "smooth",
      });

    navigate(location.pathname, {
      replace: true,
      state: {},
    });
  }
}, []);
  const isSalesPage = location.pathname === "/agents/sales";
	  const [menuOpen, setMenuOpen] = useState(false);
	  const [agentsOpen, setAgentsOpen] = useState(false);
const goToSection = (id) => {
  // Sales page
  if (isSalesPage) {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    setMenuOpen(false);
    return;
  }

  // Home page
  if (location.pathname !== "/") {
    navigate("/", {
      state: {
        scrollTo: id,
      },
    });
    return;
  }

  const el = document.getElementById(id);

  if (el) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  setMenuOpen(false);
};
	return(
		<>
			      {/* ================= NAVBAR ================= */}
  <div className="relative z-[9999] w-full px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="w-full">
          {/* Navbar */}

          <div className="mb-0">
            {/* Desktop */}
<div className="hidden lg:flex h-[72px] bg-white relative z-[9999]">
  	              {/* Logo */}
              <div className="w-[220px] flex items-center justify-center ">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-full h-full object-cover scale-[1.8]"
                  >
                    <source src={logoVideo} type="video/mp4" />
                  </video>
                </div>
              </div>

              {/* Navigation */}
<div className="relative grid grid-cols-3 w-[550px] ml-auto ">                {/* Left Vertical Gradient */}
                <div
                  className="absolute left-0 top-0 h-full w-[1.2px] z-20 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(360deg,#0C0200 0%,#E4E4E4 100%)",
                  }}
                />
                <div className="relative">
                  {/* Right Gradient */}
                  <div
                    className="absolute right-0 top-0 h-full w-[1.2px] z-20 pointer-events-none"
                    style={{
                      background:
                        "linear-gradient(360deg,#0C0200 0%,#E4E4E4 100%)",
                    }}
                  />{" "}
<Link
  to="/"
  className="h-1/2 flex items-center justify-center border-b border-[#837E7D] font-jakarta text-[14px] hover:text-[#E8604A] font-medium"
>
  Home
</Link>
              <div
  onClick={() => goToSection(isSalesPage ? "testimonials" : "testimonials")}
  className="h-1/2 flex items-center justify-center font-jakarta text-[14px] hover:text-[#E8604A] cursor-pointer"
>
  Testimonials
</div>
                </div>

                <div className="relative">
                  {/* Right Gradient */}
                  <div
                    className="absolute right-0 top-0 h-full w-[1.2px] z-20 pointer-events-none"
                    style={{
                      background:
                        "linear-gradient(360deg,#0C0200 0%,#E4E4E4 100%)",
                    }}
                  />
                  <div
  className="h-1/2"
  onMouseEnter={() => setAgentsOpen(true)}
  onMouseLeave={() => setAgentsOpen(false)}
>
  <div
    className="
      h-full
      flex
      items-center
      justify-center
      border-b
      border-[#837E7D]
      font-jakarta
      text-[14px]
      hover:text-[#E8604A]
      cursor-pointer
      transition
    "
  >
    AI Agents
  </div>

  <div
    className={`
      absolute
      top-full
      left-1/2
      -translate-x-1/2
      mt-3

      w-[250px]

      rounded-xl
      bg-white

      shadow-[0_15px_40px_rgba(0,0,0,0.12)]
      border
      border-[#ECECEC]

      transition-all
      duration-300

      ${
        agentsOpen
          ? "opacity-100 visible translate-y-0"
          : "opacity-0 invisible -translate-y-2"
      }
    `}
  >
    <Link
      to="/agents/sales"
      className="block hover:rounded-xl px-5 py-4 hover:bg-[#FFF5F3] transition"
    >
      <p className="font-semibold text-[#46453D]">
        Sales AI Agent
      </p>

      <p className="text-[13px] text-[#777] mt-1">
        AI sales calls & lead qualification
      </p>
    </Link>

    <div className="border-t" />

  </div>
</div>

                <div
onClick={()=>goToSection("contact")}
className="h-1/2 flex items-center justify-center font-jakarta text-[14px] hover:text-[#E8604A] cursor-pointer"
>
Contact
</div>
                </div>

                <div>
       <div
  onClick={() => goToSection(isSalesPage ? "features" : "features")}
  className="h-1/2 flex items-center justify-center border-b border-[#837E7D] font-jakarta text-[14px] hover:text-[#E8604A] cursor-pointer"
>
  Features
</div>

               <div
onClick={()=>goToSection("faq")}
className="h-1/2 flex items-center justify-center font-jakarta text-[14px] hover:text-[#E8604A] cursor-pointer"
>
FAQ
</div>
                </div>
              </div>

              {/* CTA */}
              <button
               onClick={()=>goToSection("live-demo")}
                className="w-[230px] bg-[#E8604A] text-white font-prompt font-semibold text-[18px] hover:bg-[#dc553e] transition mr-16"
                style={{ zoom: "0.9" }}
              >
                Try For Free
              </button>
            </div>

         
{!menuOpen && (
<div
className="relative z-[9999] flex lg:hidden items-center justify-between px-3 py-3 bg-white rounded-xl"
style={{ zoom: "0.8" }}
>             
              <div className="w-10 h-10 ml-4 rounded-full overflow-hidden">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover scale-[1.8]"
                >
                  <source src={logoVideo} type="video/mp4" />
                </video>
              </div>

              <div className="flex items-center gap-3 mr-3">
                <button 
                onClick={()=>goToSection("live-demo")}
                className="bg-[#E8604A] text-white px-4 h-10 rounded-md font-prompt font-semibold">
                  Try Free
                </button>

                <button
                  className="w-10 h-10 bg-[#E8604A] rounded-md flex items-center justify-center"
                  onClick={() => setMenuOpen(true)}
                >
                  <img src={menuIcon} alt="" className="w-6 h-6" />
                </button>
              </div>
            </div>
)}

            {/* ================= MOBILE MENU ================= */}

            <div
              onClick={() => setMenuOpen(false)}
              className={`fixed inset-0 z-50 lg:hidden transition-all duration-300
  ${
    menuOpen
      ? "bg-black/35 backdrop-blur-[2px]"
      : "bg-transparent pointer-events-none"
  }`}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className={`
      absolute
      top-3
      right-3
      bottom-3

      w-[240px]
      sm:w-[280px]

      rounded-lg
      bg-white

      shadow-[0_20px_60px_rgba(0,0,0,0.15)]

      transition-all
      duration-500
      ease-out

      ${menuOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}
    `}
              >
                {/* Header */}

                <div className="flex justify-end px-4 pt-3 ">
                  <button
                    onClick={() => setMenuOpen(false)}
                    className="
      w-6
      h-6
      rounded-full
      bg-[#F5F5F5]
      hover:bg-[#ECECEC]
      transition-all
      duration-300
      flex
      items-center
      justify-center
      text-[13px]
      hover:rotate-90
    "
                  >
                    ✕
                  </button>
                </div>

                {/* Menu */}

                <div className="">
                  {[
{
label:"Home",
action:()=>{
navigate("/")
setMenuOpen(false)
}
},
{
  label: "Testimonials",
  action: () => {
    goToSection(isSalesPage ? "testimonials" : "testimonials");
    setMenuOpen(false);
  }
},
{
label:"Sales Agent",
action:()=>{
navigate("/agents/sales")
setMenuOpen(false)
}
},
{
label:"FAQ",
action:()=>{
goToSection("faq")
setMenuOpen(false)
}},
{
label:"Contact",
action:()=>{
goToSection("contact")
setMenuOpen(false)
}},
{
  label: "Features",
  action: () => {
    goToSection(isSalesPage ? "features" : "features");
    setMenuOpen(false);
  }
},
].map((item, index) => (
                   <button
key={item.label}
onClick={item.action}
                      style={{
                        transitionDelay: menuOpen ? `${index * 60}ms` : "0ms",
                      }}
                      className={`
            w-full
            px-6
            py-2

            flex
            items-center

            text-[14px]
            font-medium
            text-[#3F3F3F]

            hover:text-[#E8604A]
            hover:bg-[#FFF5F3]

            transition-all
            duration-300

            ${
              menuOpen ? "opacity-100 translate-x-0" : "opacity-0 translate-x-5"
            }
          `}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>

                <div className="absolute bottom-5 left-5 right-5">
                  <button
                   onClick={()=>goToSection("live-demo")}
                    className="
          w-full
          h-10
          rounded-md
          bg-[#E8604A]
          text-white
          text-[14px]
          font-semibold
          hover:bg-[#d85742]
          transition
        "
                  >
                    Try For Free
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

		</>
	);
}

export default Navbar;